import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import { visitorsSearchFields } from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';

const VisitorsPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    data = [],
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property,
        direction
    },
    onPageChange,
    onPageSizeChange,
}) => {

    const columns = [{
        Header: I18n.t("visitors.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("visitors.list.email"),
        accessor: "email",
        sortable: true
    }, {
        Header: I18n.t("visitors.list.company"),
        accessor: "companyName",
        sortable: true
    }, {
        Header: I18n.t("visitors.list.mobilePhone"),
        accessor: "mobilePhone",
        sortable: false
    }];

    return <div className="page_background">
        <SearchForm
            content={visitorsSearchFields(searchFieldsValues)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={undefined}
            hideAddButton={true}
        />
        <div>
            <DataTable
                hasDelete={false}

                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
            />
        </div>
    </div>
};

VisitorsPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    handleCheckoutClicked: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
    onFetchData: PropTypes.func,
};

export default VisitorsPage;

